/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/scope */
import { Input, message, Spin, Empty, Checkbox, Button as AntdButton, Tooltip, Upload, Modal } from "antd";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { TranslateString, convertToObjectKeyString, downloadBlob } from "Utils/Common";
import SingleLoanServices from "services/services/SingleLoanServices";
import { UploadOutlined, LoadingOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import UserService from 'services/UserService';
import type { UploadProps } from 'antd';
import { useNavigate } from "react-router";
import moment from "moment";
import { useIntl } from 'react-intl';
import { useParams } from 'react-router';

const EndTendering = ({ props }: any) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [state, setState] = useState<any>(); 
    const [deleteVal, setDeleteVal] = useState<any>(); 
    const [loading, setLoading] = useState<boolean>(false);
    const [btnLoading, setBtnLoading] = useState<boolean>(false);
    const [offerList, setOfferList] = useState<any>();
    const [fileList, setFileList] = useState<any>();
    const [fileData, setFileData] = useState<any>();
    const [fileLoading, setFileLoading] = useState<boolean>(false);
    const [isWinner, setIsWinner] = useState<boolean>(false);
    const intl=useIntl();
    const params =  useParams();

    useEffect(() => {
        getLoanData(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const downloadBlobFile = async (docId:any) => {
        setLoading(true);
        await downloadBlob(docId);
        setLoading(false);
    }

    const getAllOffers = (id: any) => {
        let obj: any = {}
        obj.loan_credit_id = id;
        obj.tender_id = params?.id;
        setLoading(true);
        SingleLoanServices
            .getAllOffers(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseVal = response?.data?.data?.map((val: any, i: any) => {
                        return { ...val, checked: false }
                    })
                    setOfferList(responseVal)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    const getLoanData = (val: boolean) => {
        setLoading(true);

        let paramsId = props.id

        SingleLoanServices
            .getSingleLoanData(paramsId)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseVal = response?.data?.data
                    const fileListData = responseVal?.LOAN_DATA?.LOAN_DOC.filter((val: any) => val?.loan_status_doc_type == "tender_winner")
                    if (val) getAllOffers(responseVal?.LOAN_DATA?.loan_data_credit_id)
                    setFileList(fileListData)
                    setFileData(({ customerid: responseVal?.LOAN_DATA?.loan_data_customerid, creditid: responseVal?.LOAN_DATA?.loan_data_credit_id, loan_tender_id: paramsId, loanname: responseVal?.loan_data_name, filetype: "tender_winner" }))
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    };

    const onChange = (value: any, event: any) => {
        let valCheck = event.target.checked
        let offerListData = offerList;
        offerListData = offerListData.map((data: any) => {
            if (data?.tender_req_id == value?.tender_req_id) {
                return { ...data, checked: valCheck }
            } else {
                return { ...data, checked: false }
            }
        })
        setIsWinner(valCheck);
        setOfferList(offerListData)
    }

    const onFeedBackChange = (value: any, event: any) => {
        let offerListData = offerList;
        offerListData = offerListData.map((data: any) => {
            if (data?.tender_req_id == value?.tender_req_id) {
                return { ...data, feedback: event.target.value }
            } else {
                return data
            }
        })
        setOfferList(offerListData)
    }

    const propsFile: UploadProps = {
        name: 'file',
        action: process.env.REACT_APP_API_URL_TARGET + 'uploadmultiplepdf',
        headers: {
            Authorization: `Bearer ${UserService.getToken()}`
        },
        data: {
            filetype: fileData?.filetype,
            customerid: fileData?.customerid,
            creditid: fileData?.creditid,
            loan_tender_id: fileData?.loan_tender_id,
            loanname: fileData?.loanname
        },
        onChange(info) {
            if (info.file.status == 'uploading') {
                setFileLoading(true)
            }
            if (info.file.status === 'done') {
                setFileLoading(false)
                getLoanData(false)
                message.success(`${info.file.name} file uploaded successfully`);
            }
            if (info.file.status === 'error') {
                setFileLoading(false)
                message.error(info?.file?.response?.message);
            }
        },
        multiple: true,
        showUploadList: false,
    };

    const handleOk = () => {
        const winnerData = offerList?.map((values: any) => {
            return {
                tender_req_id: values?.tender_req_id,
                bank_id: values?.bank_id,
                BANK_DATA: values?.BANK_DATA,
                loan_tender_id: values?.loan_tender_id,
                feedback: values?.feedback,
                isWinner: values?.checked
            }
        });

        // if(isWinner && fileList.length === 0){
        //     message.error(intl.formatMessage({id: convertToObjectKeyString("please_attach_document")}));
        //     setOpen(false)
        //     return ;
        // }

        setLoading(true);
        SingleLoanServices
            .updateEndTender(winnerData, offerList[0]?.loan_tender_id)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({id: convertToObjectKeyString('tender_closed_successfully')}));
                    navigate(-1)
                    setOpen(false)
                }
                if (response?.data?.code === 500) {
                    message.error(response?.data?.msg);
                    setOpen(false)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                message.error("There was some error");
                console.log(err)
                setLoading(false);
                setOpen(false)
            });
    }

    const handleCancelPop = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        const deleteData = {
            loan_status_doc_status:0
        }
        
        setBtnLoading(true);
        SingleLoanServices
            .deleteAttachment(deleteData, deleteVal?.loan_status_id)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(response?.data?.msg);
                    getLoanData(false)
                    setOpen(false)
                }
                if (response?.data?.code === 500) {
                    message.error(response?.data?.msg);
                    setOpen(false)
                }
                setBtnLoading(false);
            })
            .catch((err: any) => {
                message.error("There was some error");
                console.log(err)
                setBtnLoading(false);
                setOpen(false)
            });
    };

    return (
        <>
            <Spin spinning={loading}>
                <div className="d-flex flex-row mb-3">
                    <div className="ms-auto">
                        <button onClick={() => { 
                            setOpen(true)
                            setState("end")
                             }} className="btn btn-sm cu-btn-green px-3 py-1">{TranslateString('end_tendering')}</button>
                    </div>
                </div>
                <div className='cu-table-border' style={{ "height": "" }}>
                    <table className="table table-sm table-bordered mb-0" >
                        <thead className="cu-bg-subgreen">
                            <tr className='cu-bg-subgreen align-top'>
                                <td scope="col" className='text-left' style={{ width: "14%" }}>{TranslateString('quotation_submit_time')}</td>
                                <td scope="col" className='text-left'>{TranslateString('to_bank')}</td>
                                <td scope="col" className='text-left' style={{ width: "16%" }}>{TranslateString('quotation_received_and_valid_until')}</td>
                                <td scope="col" className='text-left'>{TranslateString('margin')}</td>
                                <td scope="col" className='text-left'>{TranslateString('winner')}</td>
                                <td scope="col" className='text-left'>{TranslateString('feedback')}</td>
                            </tr>
                        </thead>
                        <tbody >
                            {offerList?.length > 0 ? offerList?.map((val: any) => {
                                return (
                                    <tr className='cu-text-small text-left cu-table-bg-lightgreen'>
                                        <td >{val?.tender_req_updated_at || "-"}</td>
                                        <td >{val?.BANK_DATA?.bank_name || "-"}</td>
                                        <td className="text-danger">{val?.offer_submit_at && val?.offer_valid_date ? `${val?.offer_submit_at} & ${(moment(val?.offer_valid_date).format("DD.MM.YYYY") || "-")}` : val?.offer_submit_at ? val?.offer_submit_at : val?.offer_valid_date ? (moment(val?.offer_valid_date).format("DD.MM.YYYY") || "-") : "-"}</td>
                                        <td className="text-right">{val?.offer_margin || "-"}</td>
                                        <td ><Checkbox className="p-2" checked={val?.checked} onChange={(e) => onChange(val, e)}></Checkbox></td>
                                        <td >
                                            <Input.TextArea
                                                value={val?.feedback}
                                                onChange={(e) => onFeedBackChange(val, e)}
                                                rows={3}
                                            />
                                        </td>
                                    </tr>
                                )
                            }) : <tr><td colSpan={9}><Empty description={TranslateString("Empty")}/></td></tr>}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex flex-row justify-space-between mt-3">
                    <div>
                        <span className="fw-bold">{TranslateString('attachments')}</span>
                        &nbsp;:&emsp;
                        <Upload {...propsFile} >
                            <AntdButton
                                className="cu-btn-green rounded"
                                icon={
                                    <Tooltip title={TranslateString('upload')}>
                                            {fileLoading ? <LoadingOutlined className="fs-5 text-light" /> : <UploadOutlined className="fs-5 text-light" />  }
                                    </Tooltip>
                                }>&nbsp;{TranslateString('choose_file')}&emsp;&emsp;</AntdButton>
                        </Upload>
                    </div>

                </div>
                <Row>
                    <Col sm={6}>
                        <div className='mt-4 cu-table-border' style={{ "height": "" }}>
                            <table className="table table-sm table-bordered mb-0" >
                                <thead className="cu-bg-subgreen">
                                    <tr className='cu-bg-subgreen align-top text-center'>
                                        <td scope="col">{TranslateString('attachments')}</td>
                                        <td scope="col">{TranslateString('actions')}</td>
                                    </tr>
                                </thead>
                                <tbody >
                                    {fileList?.length > 0 ? fileList?.map((val: any, index: any) => {
                                        return (
                                            <tr className='cu-text-small text-left cu-table-bg-lightgreen'>
                                                <td className="text-center">{`${TranslateString('attachment')} ${index + 1}`}</td>
                                                <td className="text-center" role='button'>
                                                    <div className="d-flex justify-content-center">
                                                        <div>
                                                            <a className="cu-color-right" 
                                                            href='javascript:void(0)'
                                                            onClick={() => {
                                                                downloadBlobFile(val?.loan_status_id)
                                                            }}
                                                            rel='noopener noreferrer'>
                                                                <Tooltip title={TranslateString('view')}>
                                                                    <EyeOutlined
                                                                        className="fs-5"
                                                                    />
                                                                </Tooltip>
                                                            </a>
                                                        </div>
                                                        <div>&nbsp;</div>
                                                        <div>
                                                            <Tooltip title={TranslateString('delete')}>
                                                                <DeleteOutlined
                                                                    className="fs-5"
                                                                    onClick={() => {
                                                                        setDeleteVal(val)
                                                                        setOpen(true)
                                                                        setState("delete")
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={9}><Empty description={TranslateString('Empty')}/></td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </Spin>
            <Modal
                title=""
                open={open}
                onOk={()=>{
                    state == "end" ? handleOk() : handleDelete()
                }}
                okButtonProps={{ className: 'cu-bg-green' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green' }}
                onCancel={handleCancelPop}
                confirmLoading={btnLoading}
            >
                <p className='h5'>{state == "end" ? TranslateString('are_you_sure_you_want_to_end_this_tender') : TranslateString('are_you_sure_you_want_to_delete_this_attachment')}</p>
            </Modal>
        </>
    );
};
export default EndTendering;